import { useIsMobile } from '@stores/AppCommonData';
import styled from '@emotion/styled';
import { Spacings, mediaQuery, Fonts } from '@styles/index';
import Image from '@base/Image';
import AquillaButton from 'aquilla/core/molecules/Button';
import H6 from '@base/H6/H6';
import H4 from '@base/H4/H4';
import { emptyObject } from '@constants/empty';
import AutoScroller from './AutoScroller';

const WonWrapper = styled.div`
  border: 1px solid var(--color-divider);
  border-radius: ${Spacings.SPACING_2B};
  width: 1136px;
  margin: ${Spacings.SPACING_20B} auto ${Spacings.SPACING_0B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_0B};
    border-width: ${Spacings.SPACING_0B};
    width: 100%;
    padding: 0px 16px;
  }
`;

const WonLeftWrapper = styled.div`
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  justify-content: space-between;
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_10B};
    gap: ${Spacings.SPACING_0B};
    flex-basis: 100%;
    text-align: left;
    align-items: start;
    border: 1px solid var(--color-i-divider);
    border-radius: ${Spacings.SPACING_2B};
  }
`;

const TextWrapper = styled.div`
  width: 402px;
  padding: 24px;
  ${mediaQuery.uptoMobile} {
    width: 206px;
    padding: ${Spacings.SPACING_4B} ${Spacings.SPACING_0B}
      ${Spacings.SPACING_4B} ${Spacings.SPACING_4B};
  }
`;

const WonDescription = styled(H6)`
  color: var(--color-text-secondary);
  font-weight: ${Fonts.LIGHT};
  margin-top: ${Spacings.SPACING_1B};
  ${mediaQuery.uptoMobile} {
    margin-top: ${Spacings.SPACING_2B};
    font-weight: ${Fonts.LIGHT};
    font-size: ${Fonts.ULTRA_SMALL};
    line-height: ${Fonts.LARGE};
    width: 206px;
  }
`;

const WonTitle = styled(H4)`
  ${mediaQuery.uptoMobile} {
    font-style: normal;
    font-weight: ${Fonts.SEMIBOLD};
    font-size: ${Fonts.LARGE};
    line-height: ${Spacings.SPACING_6B};
  }
`;
const WonIcon = styled.div`
  position: relative;
  width: 50%;
  height: 208px;
  flex-shrink: ${Spacings.SPACING_0B};
  ${mediaQuery.uptoMobile} {
    height: 134px;
    width: 108px;
  }
  img {
    border-radius: ${Spacings.SPACING_2B};
  }
`;

const ViewWinnersCta = styled(AquillaButton)`
  margin-top: ${Spacings.SPACING_4B};
  ${mediaQuery.uptoMobile} {
    display: none;
  }
`;

const ScrollerWrapper = styled.div`
  ${mediaQuery.uptoMobile} {
    display: none;
  }
  margin-top: ${Spacings.SPACING_3B};
`;

const LaptopWonBlock = ({ wonData, scrollTOHallOfFame, socialProofing }) => {
  const { subHeading, heading = emptyObject } = wonData ?? emptyObject;
  const { socialProofingData } = socialProofing || emptyObject;
  const isMobile = useIsMobile();
  return (
    <WonWrapper>
      <WonLeftWrapper>
        <WonIcon>
          <Image
            src={
              isMobile
                ? 'referrals/laptopWonMobile.svg'
                : 'referrals/wonIcon.svg'
            }
            layout="fill"
            alt="won"
          />
        </WonIcon>
        <TextWrapper>
          <WonTitle>
            Congratulations,
            {isMobile ? <br /> : ' '}
            {heading}!
          </WonTitle>
          <WonDescription>{subHeading}</WonDescription>
          {socialProofingData && (
            <ScrollerWrapper>
              <AutoScroller socialProofingData={socialProofingData} />
            </ScrollerWrapper>
          )}

          <ViewWinnersCta
            variant="secondary"
            size="medium"
            onClick={scrollTOHallOfFame}
          >
            View winners
          </ViewWinnersCta>
        </TextWrapper>
      </WonLeftWrapper>
    </WonWrapper>
  );
};

export default LaptopWonBlock;
